import React, { CSSProperties } from "react";

interface StatusCellProps {
  status: string;
}

const StatusCell: React.FC<StatusCellProps> = ({ status }) => {
  const getStatusStyles = (): CSSProperties => {
    switch (status?.toLowerCase()) {
      case "confirmed":
      case "success":
        return {
          color: "#63aa84",
          fontWeight: "600", 
        };
      case "pending":
      case "on_hold":
      case "inprogress":
      case "in_progress":
        return {
          color: "#fc9458", 
          fontWeight: "600",
        };
      case "failed":
        return {
          color: "#f25353", 
          fontWeight: "600",
        };
      default:
        return {
          color: "#6c757d", 
          fontWeight: "600",
        };
    }
  };

  return <span style={getStatusStyles()}>{status.toUpperCase()}</span>;
};

export default StatusCell;
